import { API_ENDPOINTS } from "../apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const loginApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginEmployee: builder.mutation({
      query: ({ authCredentials }) => ({
        url: API_ENDPOINTS.login.loginEmployee(),
        method: "POST",
        body: authCredentials,
      }),
      transformResponse: (response) => {
        console.log("Raw Response -> ", response?.data);
        return response.data;
      },
      invalidatesTags: ["Login"],
    }),
    microsoftLogin: builder.mutation({
      query: ({ authCredentials }) => ({
        url: API_ENDPOINTS.microsoftLogin.microsoftLogin(),
        method: "POST",
        body: authCredentials,
      }),
      transformResponse: (response) => {
        console.log("Raw Response -> ", response?.data);
        return response.data;
      },
    }),
    googleLogin: builder.mutation({
      query: (body) => ({
        url: API_ENDPOINTS.googleLogin.googleLogin(),
        method: "POST",
        body,
      }),
      transformResponse: (response) => response.data,
    }),

    fetchforgotpassword: builder.query({
      transformResponse: (response) => response?.data,
      query: (empId) => ({
        url: API_ENDPOINTS.forgotPassword.forgotPassword(empId),
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [{ type: "Login", id: "LIST" }]
          : [{ type: "Login", id: "LIST" }],
    }),
    forgotPasswordMail: builder.mutation({
      query: (values) => ({
        url: API_ENDPOINTS.forgotPasswordMail.forgotPasswordMail(),
        method: "POST",
        body: values,
      }),
    }),
    resetPassword: builder.mutation({
      query: (values) => ({
        url: API_ENDPOINTS.resetPassword.resetPassword(),
        method: "PUT",
        body: values,
      }),
    }),
    refreshTokenCheck: builder.mutation({
      query: (values) => ({
        url: API_ENDPOINTS.refreshTokenCheck.refreshTokenCheck(),
        method: "POST",
        body: values,
      }),
    }),
  }),
});

export const {
  useLoginEmployeeMutation,
  useLazyFetchforgotpasswordQuery,
  useForgotPasswordMailMutation,
  useResetPasswordMutation,
  useMicrosoftLoginMutation,
  useRefreshTokenCheckMutation,
  useGoogleLoginMutation,
} = loginApi;
